import React from 'react'
import { Tooltip } from '../../common'
import { INTEGRAL_LP_FARMING_URL } from '../../constants'

export function PoolRatioTooltip() {
  return (
    <Tooltip>
      <p>Make single-sided deposits to change "POOL RATIO".</p>
      <p>
        Learn more{' '}
        <a href={INTEGRAL_LP_FARMING_URL} target="_blank">
          here
        </a>
        .
      </p>
    </Tooltip>
  )
}
